import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import format from 'date-fns/format';
import common from 'constants/common';

const PriorAuth = ({ priorAuths }) => (
  <>
    <h5>Prior authorization</h5>
    <Table borderless border="0" cellSpacing="0" cellPadding="0">
      <thead>
        <tr>
          <th>
            <div className="pagination-container">
              <h5>Number</h5>
            </div>
          </th>
          <th>
            <div className="pagination-container">
              <h5>Date Range</h5>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        {priorAuths.map((priorAuth) => (
          <tr>
            <td>{priorAuth.authorizationNumber}</td>
            <td>
              <span>
                {format(
                  new Date(priorAuth.startDate),
                  common.dateFormats.priorAuthorizationAdmin,
                )}{' '}
                to{' '}
                {format(
                  new Date(priorAuth.endDate),
                  common.dateFormats.priorAuthorizationAdmin,
                )}
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </>
);

PriorAuth.propTypes = {
  priorAuths: PropTypes.array.isRequired,
};

export default PriorAuth;
